import { h } from 'preact';

import { useCallback } from 'preact/hooks';

import { Match } from 'preact-router/match';

import ListItemButton from '@mui/material/ListItemButton';

import styles from '../styles.css';
import { KappaLink } from '../router/router.jsx';
import { PUBLIC_FOLDER } from '../../consts.js';

function contentRenderer(href, children) {
  function onMatch({ matches }) {
    if (matches) {
      return (
        <KappaLink
          href={href}
          activeClassName={styles.activeLink}
          class={styles.reactiveLink}
        >
          <ListItemButton inset selected>
            {children}
          </ListItemButton>
        </KappaLink>
      );
    } else {
      return (
        <KappaLink
          href={href}
          activeClassName={styles.activeLink}
          class={styles.reactiveLink}
        >
          <ListItemButton inset>{children}</ListItemButton>
        </KappaLink>
      );
    }
  }

  return onMatch;
}

export default function ReactiveItemLink(props) {
  const { href, children } = props;

  const conditionalMatch = useCallback(contentRenderer(href, children), [
    href,
    children,
  ]);

  return <Match path={`${PUBLIC_FOLDER}${href}`}>{conditionalMatch}</Match>;
}
